import { motion } from "framer-motion";

const STATS = [
  { label: "Erfarenhet", value: "15 år" },
  { label: "Team", value: "3 hantverkare" },
  { label: "Specialitet", value: "Fjärrvärmecentraler" },
  { label: "Område", value: "Storstockholm" },
];

export default function About() {
  return (
    <section id="om-mig" data-testid="about-section" className="border-b border-white/10 py-20 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-4 sm:px-6 lg:grid-cols-12 lg:gap-10 lg:px-8">
        <motion.div
          initial={{ opacity: 0, x: -32 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
          className="space-y-5 lg:col-span-5"
        >
          <div className="steel-card hairline-t border border-white/10 p-2">
            <div className="overflow-hidden">
              <img
                src="/assets/fredrik-van.webp"
                alt="Fredrik framför Uusimaa Svets & VVS AB:s servicebil"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
              />
            </div>
            <p className="flex items-center justify-between px-3 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
              <span>Fredrik — Grundare, Uusimaa Svets & VVS AB</span>
              <span className="text-weld">FIG. 02</span>
            </p>
          </div>
          <div className="steel-card hairline-t border border-white/10 p-2">
            <div className="overflow-hidden">
              <img
                src="/assets/fredrik-working.webp"
                alt="Noggrant montage av rörinstallation – Uusimaa Svets & VVS AB"
                loading="lazy"
                className="aspect-[4/3] w-full object-cover transition-transform duration-700 hover:scale-[1.03]"
              />
            </div>
            <p className="flex items-center justify-between px-3 py-3 font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">
              <span>Noggrannhet i varje moment</span>
              <span className="text-weld">FIG. 03</span>
            </p>
          </div>
        </motion.div>

        <div className="lg:col-span-7">
          <motion.div
            initial={{ opacity: 0, y: 28 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <p className="font-mono text-xs uppercase tracking-[0.22em] text-neutral-500">04 / Om oss</p>
            <h2 className="mt-4 font-display text-4xl font-bold uppercase leading-none tracking-tight text-white sm:text-5xl">
              Ett litet team med höga krav
            </h2>
            <div className="mt-8 max-w-2xl space-y-5 text-base leading-relaxed text-neutral-300 sm:text-lg">
              <p>
                Uusimaa Svets &amp; VVS AB drivs av Fredrik tillsammans med två kollegor. Med 15 års erfarenhet i
                yrket är vi i dag tre hantverkare som arbetar praktiskt med det vi tycker om – och att bygga något
                eget har länge varit ett mål.
              </p>
              <p>
                Vi gillar att lösa problem, hitta bra lösningar och framför allt lämna ifrån oss arbeten som vi själva
                är nöjda med. Vår vanligaste uppgift är byte av fjärrvärmecentraler, men vi tar även arbeten inom
                VVS, rör och svetsning i hela Storstockholm.
              </p>
              <p className="italic text-neutral-400">
                ”På fritiden hittar du mig på gymmet eller inom motorsporten – samma fokus tar jag med mig till varje
                arbetsplats.”
              </p>
              <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-neutral-500">
                — Fredrik, grundare, född 1993
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ delay: 0.15, duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
            className="mt-12 grid grid-cols-2 gap-px border border-white/10 bg-white/10 lg:grid-cols-4"
            data-testid="about-stats"
          >
            {STATS.map((s) => (
              <div key={s.label} className="bg-coal p-5">
                <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-neutral-500">{s.label}</p>
                <p className="mt-2 font-display text-xl font-semibold uppercase tracking-tight text-white">
                  {s.value}
                </p>
              </div>
            ))}
          </motion.div>
        </div>
      </div>
    </section>
  );
}
